import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { RegexUsername } from "configs/regex";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { editUser } from "../../../../utils/action";
import { InputText, setTitleCase } from "../../../components/template/partials";

// inital values form
const initialValues = (autoComplete) => {
  return {
    username: autoComplete?.username ?? "",
    role: autoComplete?.role ?? null,
    email_nohp: autoComplete?.email_nohp ?? "",
    nama_lengkap: autoComplete?.nama_lengkap ?? "",
    keterangan: autoComplete?.keterangan ?? "",
  };
};

// form field validation schema
const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Nama Pengguna wajib diisi!")
    .matches(RegexUsername, "Format Nama Pengguna tidak sesuai"),
  nama_lengkap: Yup.string().required("Nama Lengkap wajib diisi!"),
});

export function EditUser() {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const showDialog = location.state?.showDialog ?? false;
  const userData = location.state?.userData ?? null;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const onHide = () => {
    navigate(-1);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      username: values.username,
      role: values.role?.value,
      email_nohp: values.email_nohp,
      nama_lengkap: values.nama_lengkap,
      keterangan: values.keterangan,
    };

    // send to backend
    try {
      await editUser(request);
      toast.success(setTitleCase("berhasil mengedit data pengguna"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-create-customer-title"
    >
      <DialogTitle id="responsive-dialog-create-customer-title">
        Edit Pengguna
      </DialogTitle>
      <Divider />
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues(userData)}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="username"
                    label="Nama User"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="email_nohp"
                    label="Nomor HP"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="nama_lengkap"
                    label="Nama Lengkap"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="keterangan"
                    label="Keterangan Pengguna"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Batal
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
